import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { PersistPartnerRequest } from "../../models/manage/zeroharmPartner.models";

@autoinject()
export class ZeroHarmPartnersClientService {

    constructor(private requestClient: RequestClientService) { }

    delete(ids: number[]): Promise<any> {
        return this.requestClient.post<any>("zeroharmPartner/delete", { ids: ids });
    }

    getPartner(id: number): Promise<any> {

        return new Promise((resolve, reject) => {
            this.requestClient.get<any>("zeroharmPartner/get/" + id, {}).then(x => {
                resolve(x);
            }, err => {
                reject(err);
            }).catch(err => {
                reject(err);
            });
        });

    }

    save(request: PersistPartnerRequest): Promise<any> {
        return this.requestClient.post("zeroharmPartner/save", {}, request);
    }

    getZeroHarmPartnerByVesselIdentifier(imo: string, vin: string, eni: string): Promise<any> {

        return new Promise((resolve, reject) => {
            this.requestClient.get<any>("zeroharmPartner/GetByVesselIdentifier", { imo: imo ?? 0, vin: vin ?? 0, eni: eni ?? 0 }).then(x => {
                resolve(x);
            }, err => {
                reject(err);
            }).catch(err => {
                reject(err);
            });
        });

    }

    getPotentialPartnersByVesselIdentifier(vesselId: number, imo: string, vin: string, eni: string): Promise<any> {

        return new Promise((resolve, reject) => {
            this.requestClient.get<any>("zeroharmPartner/GetPotentialPartnerByVesselIdentifier", { imo: imo ?? 0, vin: vin ?? 0, eni: eni ?? 0, vesselId: vesselId }).then(x => {
                resolve(x);
            }, err => {
                reject(err);
            }).catch(err => {
                reject(err);
            });
        });
    }
}
